import { Tooltip } from "flowbite-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { HiOutlineBan, HiOutlineEye, HiOutlinePencil, HiOutlineRefresh, HiOutlineTrash } from "react-icons/hi"



type TableActionProps = {
   action: 'view' | 'activate' | 'deactivate' | 'edit' | 'delete'
   disabled?: boolean
   tooltip?: boolean
   onClick?: () => void
   isFirst?: boolean
}

const actionIcon = (action: string, disabled: boolean = false) => {
   switch (action) {
      case "view":
         return <HiOutlineEye size={20} color={disabled ? "#e7e7e7" : "black"} />

      case "activate":
         return <HiOutlineRefresh size={20} color={disabled ? "#e7e7e7" : "black"} />

      case "deactivate":
         return <HiOutlineBan size={20} color={disabled ? "#e7e7e7" : "black"} />

      case "edit":
         return <HiOutlinePencil size={20} color={disabled ? "#e7e7e7" : "black"} />

      case "delete":
         return <HiOutlineTrash size={20} color={disabled ? "#e7e7e7" : "black"} />
   }
}

const TableAction: React.FC<TableActionProps> = ({ action, disabled, tooltip = true, onClick, isFirst = false }) => {
   const [t] = useTranslation()
   const marginClass = isFirst ? '' : 'ml-2.5'

   return (
      tooltip
         ? <Tooltip content={<p className="font-medium text-sm mb-0">{t(`common.${action}`)}</p>}>
            <button
               disabled={disabled}
               className={`flex items-center justify-center w-8.5 h-8.5 hover:enabled:bg-border rounded-md disabled:cursor-not-allowed ${marginClass}`}
               onPointerDown={(e) => e.stopPropagation()}
               onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()

                  onClick?.()
               }}>
               {actionIcon(action, disabled)}
            </button>
         </Tooltip >
         : <button
            disabled={disabled}
            className={`flex items-center justify-center w-8.5 h-8.5 hover:enabled:bg-border rounded-md ${marginClass}`}
            onPointerDown={(e) => e.stopPropagation()}
            onClick={(e) => {
               e.preventDefault()
               e.stopPropagation()

               onClick?.()
            }}>
            {actionIcon(action, disabled)}
         </button>
   )
}

export default TableAction